import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Element} from "react-scroll";
import Grid from "@material-ui/core/Grid";
import Breadcrumbs from "../Breadcrumbs";
import Steps from "../Steps";
import Container from "../Container";
import steps from "../../mocks/steps";
import {haveResultsSelector} from "../../ducks/results";

import styles from "./header.module.scss";

function Header(props) {
  const {haveResults} = props;
  return (
    <Grid container className={styles.root}>
      <Container>
        <Fragment>
          <Grid item xs={12}>
            <Element name="header-scroll-element" />
            <Breadcrumbs
              items={
                haveResults
                  ? [
                      {
                        title: `Главная`,
                        path: `/podarki`
                      },
                      {
                        title: `Подобрать подарок`,
                        path: `/podobrat-podarok`
                      },
                      {
                        title: `Идеи для подарков`
                      }
                    ]
                  : [
                      {
                        title: `Главная`,
                        path: `/podarki`
                      },
                      {
                        title: `Подобрать подарок`
                      }
                    ]
              }
            />
          </Grid>
          <Grid item xs={12}>
            {haveResults ? (
              <section>
                <h1 className={styles.title}>Идеи для подарков</h1>
                <p className={styles.description}>
                  Подобранные варианты подарков по Вашим параметрам:
                </p>
              </section>
            ) : (
              <section>
                <h1 className={styles.title}>Подобрать подарок</h1>
                <Steps items={steps} />
              </section>
            )}
          </Grid>
        </Fragment>
      </Container>
    </Grid>
  );
}

Header.propTypes = {
  haveResults: PropTypes.bool
};

export default connect((state) => ({
  haveResults: haveResultsSelector(state)
}))(Header);
